import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .overlayWidgets{left:0;position:absolute;top:0}";
n(css,{});
export { css, css as default };
